import $ from 'jquery';
import React from 'react/addons';

import {init as simpleChoiceInit} from 'ofs/components/simple-choice/SimpleChoice';
import DatePicker from 'ofs/components/DatePickerNext';


function hideDrawer($drawer) {
  $drawer
    .removeClass('ofs-NavigationDrawer--is-visible')
    .data('open', false);

  return $drawer;
}

function openDrawer($drawer) {
  $drawer
    .addClass('ofs-NavigationDrawer--is-visible')
    .data('open', true);

  return $drawer;
}

// headerSearch should always show on the homepage
function safeHideHeaderSearch($headerSearch) {
  if (!$headerSearch.data('always-visible')) {
    $headerSearch
      .removeClass('ofs-HeaderSearch--is-visible')
      .data('open', false);
  }
}

function initDrawers() {
  // WARNING: jQuery soup ahead
  var $headerSearch = $('.ofs-HeaderSearch').data('open', false);
  var $searchDrawer = $('#search-navigation-drawer').data('open', false);
  var $serviceDrawer = $('#service-navigation-drawer').data('open', false);
  var $accountDrawer = $('#account-navigation-drawer').data('open', false);
  var $contactDrawer = $('#contact-navigation-drawer').data('open', false);

  $('#search-toggle').on('click', function(event) {
    event.preventDefault();
    $('.ofs-GlobalHeader__MenuItem').removeClass('ofs-GlobalHeader__MenuItem--active');
    if ($searchDrawer.data('open')) {
      hideDrawer($searchDrawer);
      safeHideHeaderSearch($headerSearch);
    } else {
      $(this).addClass('ofs-GlobalHeader__MenuItem--active');
      openDrawer($searchDrawer);
      hideDrawer($serviceDrawer);
      hideDrawer($accountDrawer);
      $headerSearch
        .addClass('ofs-HeaderSearch--is-visible')
        .data('open', true);
    }
  });

  $('#service-toggle').on('click', function(event) {
    event.preventDefault();
    $('.ofs-GlobalHeader__MenuItem').removeClass('ofs-GlobalHeader__MenuItem--active');
    if ($serviceDrawer.data('open')) {
      hideDrawer($serviceDrawer);
    } else {
      $(this).addClass('ofs-GlobalHeader__MenuItem--active');
      openDrawer($serviceDrawer);
      hideDrawer($searchDrawer);
      hideDrawer($accountDrawer);
      safeHideHeaderSearch($headerSearch);
    }
  });

  $('#account-toggle').on('click', function(event) {
    event.preventDefault();
    $('.ofs-GlobalHeader__MenuItem').removeClass('ofs-GlobalHeader__MenuItem--active');
    if ($accountDrawer.data('open')) {
      hideDrawer($accountDrawer);
    } else {
      $(this).addClass('ofs-GlobalHeader__MenuItem--active');
      openDrawer($accountDrawer);
      hideDrawer($searchDrawer);
      hideDrawer($serviceDrawer);
      safeHideHeaderSearch($headerSearch);
    }
  });

  $('#mobile-search-toggle').on('click', function(event) {
    event.preventDefault();
    $headerSearch.toggleClass('ofs-HeaderSearch--is-visible');
    hideDrawer($contactDrawer);
  });

  $('#mobile-contact-toggle').on('click', function(event) {
    event.preventDefault();

    if ($contactDrawer.data('open')) {
      hideDrawer($contactDrawer);
    } else {
      openDrawer($contactDrawer);
      hideDrawer($searchDrawer);
      hideDrawer($accountDrawer);
      $headerSearch
        .removeClass('ofs-HeaderSearch--is-visible')
        .data('open', false);
    }
  });
}


export default function init() {
  initDrawers();

  // init search form
  const region = simpleChoiceInit($('#header-quicksearch_region'));
  const sleeps = simpleChoiceInit($('#header-quicksearch_sleeps'));
  region.classList.add('bdd-quicksearch-field-region');
  sleeps.classList.add('bdd-quicksearch-field-sleeps');

  // init datepickers
  var startDate = $('#header-quicksearch_start_date').val();
  var endDate = $('#header-quicksearch_end_date').val();

  if (startDate && endDate) {
    startDate = new Date(startDate);
    endDate = new Date(endDate);
  } else {
    startDate = null;
    endDate = null;
  }

  var datePickerEl = document.getElementById('header-quicksearch_date_picker');

  if (datePickerEl) {
    React.render(
      <DatePicker startValue={startDate} endValue={endDate} />,
      datePickerEl
    );
  }
}



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/core/views/Header.jsx
 **/